// per 9/01/14 fees
const FEE = {
  LERSTF: 1,
  FRVIS: 0.50,
  DecalOnDemand: 1,
  ServiceFee: 2.25,
};

export default FEE;
